import script from "./ProductPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductPage.vue?vue&type=script&setup=true&lang=ts"

import "./ProductPage.vue?vue&type=style&index=0&id=cac64e92&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cac64e92"]])

export default __exports__